module.exports = __webpack_public_path__ + "img/marker_five_green1.35b22200.png";